import { apiRequest } from './client.js';
export async function login(email, password) {
    return apiRequest('/auth/login', {
        method: 'POST',
        body: { email, password },
    });
}
export async function fetchMe() {
    return apiRequest('/auth/me', { auth: true });
}
